import { createAction, props } from '@ngrx/store';
import { Plant } from '../../models/plant.model';

export const loadPlants = createAction('[Plant] Load Plants');
export const loadPlantsSuccess = createAction(
  '[Plant] Load Plants Success',
  props<{ plants: Plant[] }>(),
);
export const loadPlantsFailure = createAction(
  '[Plant] Load Plants Failure',
  props<{ error: any }>(),
);
